import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';

export default async function customDeleteAddress(context: Context, params: CustomQuery): Promise<ApiResult> {
  // console.log('api.getProduct...-------', params);
  const url = new URL('/mall/address/delete', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
